import homePage from "@/components/homePage/index.vue";
export default {
  path: "/distribution",
  component: homePage,
  redirect: "/distribution/customerInquiry",
  meta: { title: "分销管理" },
  children: [
    {
      path: "customerInquiry",
      component: () =>
        import("@/module/distributionMudule/viewPage/customerInquiry.vue"),
      meta: { title: "分销客户询价" },
    },
    {
      path: "customerOffer",
      component: () =>
        import("@/module/distributionMudule/viewPage/customerOffer.vue"),
      meta: { title: "分销报价" },
    },
    {
      path: "order",
      component: () =>
        import("@/module/distributionMudule/viewPage/customerOrder.vue"),
      meta: { title: "分销订单" },
    },
    {
      path: "clientIndex",
      component: () =>
        import("@/module/distributionMudule/viewPage/clientIndex.vue"),
      meta: { title: "分销客户" },
    },

    
  ],
};
